<template>
  <Bar class="custom-class" :chart-options="chartOptions" :chart-data="chartData" :chart-id="chartId"
    :dataset-id-key="datasetIdKey" :plugins="plugins" :css-classes="cssClasses" :styles="styles" />
</template>

<script>
import { Bar } from 'vue-chartjs/legacy'

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
} from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)
export default {
  components: {
    Bar
  },
  props: {
    chartId: {
      type: String,
      default: 'bar-chart'
    },
    datasetIdKey: {
      type: String,
      default: 'label'
    },
    width: {
      type: Number,
      default: 1200
    },
    height: {
      type: Number,
      default: 400
    },
    cssClasses: {
      default: '',
      type: String
    },
    styles: {
      type: Object,
      default: () => ({})
    },
    plugins: {
      type: Object,
      default: () => ({})
    },
    dashboardData: {
      type: Object,  // Мы ожидаем объект
      default: () => ({})
    },
  },
  data() {
    return {
      // chartData: {
      //   labels: [
      //     "1.09",
      //     "2.09",
      //     "3.09",
      //     "4.09",
      //     "5.09",
      //     "6.09",
      //     "7.09",
      //     "1.09",
      //     "2.09",
      //     "3.09",
      //     "4.09",
      //     "5.09",
      //     "6.09",
      //     "1.09",
      //     "2.09",
      //     "3.09",
      //     "4.09",
      //     "5.09",
      //     "6.09"
      //   ],
      //   datasets: [
      //     {
      //       label: 'В зале',
      //       backgroundColor: '#13414E',
      //       data: [25000, 28000, 15000, 55000, 37000, 40000, 20000, 25000, 28000, 15000, 55000, 37000, 40000, 25000, 28000, 15000, 55000, 37000, 40000]
      //     },
      //     {
      //       label: 'Доставка',
      //       backgroundColor: '#006D5A',
      //       data: [65000, 18000, 45000, 25000, 37000, 60000, 57000, 25000, 28000, 15000, 55000, 37000, 40000, 25000, 28000, 15000, 55000, 37000, 40000]
      //     },
      //     {
      //       label: 'На вынос',
      //       backgroundColor: '#14BF91',
      //       data: [15000, 48000, 35000, 75000, 47000, 20000, 17000, 25000, 28000, 15000, 55000, 37000, 40000, 25000, 28000, 15000, 55000, 37000, 4000]
      //     }
      //   ]
      // },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
                interaction: {
          mode: 'index',
          intersect: true,
        },
        plugins: {
          datalabels: {
            display: false
          },
          legend: {
            labels: {
              font: {
                family: 'Inter', // Шрифт для легенды
                size: 15, // Размер шрифта для легенды
              },
              color: '#323c4d' // Цвет шрифта для легенды
            }
          },
          tooltip: {
          enabled: false, 
          position: 'nearest',
          external: function(context) {
            const { chart, tooltip } = context;
            let tooltipEl = chart.canvas.parentNode.querySelector('div.custom-chartjs-tooltip');

            // 1. Создаем контейнер, если его нет
            if (!tooltipEl) {
              tooltipEl = document.createElement('div');
              tooltipEl.classList.add('custom-chartjs-tooltip');
              // Стилизуем под ваш скриншот (темно-серый фон, скругления 4px)
              Object.assign(tooltipEl.style, {
                background: 'rgba(50, 50, 50, 0.95)',
                borderRadius: '4px',
                color: '#ffffff',
                opacity: 1,
                pointerEvents: 'none',
                position: 'absolute',
                transition: 'all 0.1s ease',
                padding: '5px 7px',
                fontFamily: 'Inter, sans-serif',
                fontSize: '13px',
                minWidth: '255px',
                zIndex: 999,
                boxShadow: '0 4px 6px rgba(0,0,0,0.3)'
              });
              chart.canvas.parentNode.appendChild(tooltipEl);
            }

            // 2. Прячем тултип, если убрали мышку
            if (tooltip.opacity === 0) {
              tooltipEl.style.opacity = 0;
              return;
            }

            // 3. Собираем HTML как на скриншоте
            const title = tooltip.title[0] || '';
            let total = 0;
            tooltip.dataPoints.forEach(dp => {
                    total += dp.raw;
            });

            // Шапка: Дата и Итого
            let innerHtml = `
              <div style="font-weight: 700; font-size: 14px; margin-bottom: 3px;">${title}</div>
              <div style="margin-bottom: 3px;">Итого: ${total.toLocaleString('ru-RU')} ₸ </div>
            `;

            // Строки (Квадратик с белой рамкой + текст)
              tooltip.dataPoints.forEach(dp => {
                const color = dp.dataset.backgroundColor;
                const label = dp.dataset.label;
                const val = dp.raw;
                
                if (val !== null && val !== undefined) {
                  innerHtml += `
                    <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 4px; width: 100%;">
                      
                      <div style="display: flex; align-items: center;">
                        <span style="display: inline-block; width: 14px; height: 14px; background: ${color}; border: 1px solid #ffffff; border-radius: 1px; margin-right: 6px;"></span>
                        <span>- ${label}</span>
                      </div>

                      <span style="margin-left: 20px; font-weight: 500;">${val.toLocaleString('ru-RU')} ₸</span>
                      
                    </div>
                  `;
                }
              });

            tooltipEl.innerHTML = innerHtml;

            // 4. УМНОЕ ПОЗИЦИОНИРОВАНИЕ (Решает проблему обрезания)
            tooltipEl.style.opacity = 1;
            
            // Если курсор находится в правой половине графика -> показываем тултип СЛЕВА
            // Если в левой половине -> показываем СПРАВА
            if (tooltip.caretX > chart.width / 2) {
              tooltipEl.style.transform = 'translate(calc(-100% - 15px), -50%)'; 
            } else {
              tooltipEl.style.transform = 'translate(15px, -50%)'; 
            }

            tooltipEl.style.left = tooltip.caretX + 'px';
            tooltipEl.style.top = tooltip.caretY + 'px';
          }
        }
        },
        scales: {
          x: {
            stacked: true,
            categoryPercentage: 0.3, // Процент от ширины доступной категории (0.0 до 1.0)
            barThickness: 100,
            ticks: {
              // callback: function(value) {
              //   return value.replace(/\s+/g, ' '); // Удаляет пробелы, если они не поддерживаются
              // },
              rotation: 0,
              align: 'center',
              font: {
                family: 'Inter', // Шрифт для оси X
                size: 12, // Размер шрифта для оси X
              },
              color: '#000000' // Цвет шрифта для оси X
            }
          },
          y: {
            stacked: true,
            ticks: {
              font: {
                family: 'Inter', // Шрифт для оси Y
                size: 12, // Размер шрифта для оси Y
              },
              color: '#000000' // Цвет шрифта для оси Y
            }
          }
        }
      }
    }
  },
  methods: {
    formatDate(dateString) {
      const date = new Date(dateString);
      // Форматируем дату в нужный формат (например, "дд.мм")
      return `${String(date.getDate()).padStart(2, '0')}.${String(date.getMonth() + 1).padStart(2, '0')}`;
    }
  },
  computed: {
    chartData() {
      // const { dailyRevenues } = this.dashboardData;
      const dailyRevenues = this.dashboardData.dailyRevenues || [];

      // Получаем метки и данные для каждого дня
      const labels = dailyRevenues.map(item => {
        const date = new Date(item.date);
        const dayOfWeek = (date.toLocaleDateString('ru-RU', { weekday: 'short' }));
        const formattedDate = this.formatDate(item.date);
        //       if (dayOfWeek === 'сб' || dayOfWeek === 'вс') {
        //   return [`🔴 ${dayOfWeek}`, formattedDate]; // Пример: "🔴 Сб\n01.09"
        // } else {
        return [dayOfWeek, formattedDate]
      });
      const inHouseData = dailyRevenues.map(item => (item.inHouseRevenue === 0 || !item.inHouseRevenue) ? null : item.inHouseRevenue);
      const deliveryData = dailyRevenues.map(item => (item.deliveryRevenue === 0 || !item.deliveryRevenue) ? null : item.deliveryRevenue);
      const selfPickUpData = dailyRevenues.map(item => (item.selfPickUpRevenue === 0 || !item.selfPickUpRevenue) ? null : item.selfPickUpRevenue);

      return {
        labels: labels,

        datasets: [
          {
            label: 'В зале',
            backgroundColor: '#13414E',
            data: inHouseData,
            // barThickness: 66,
            // categoryPercentage: 1,


          },
          {
            label: 'Доставка',
            backgroundColor: '#006D5A',
            data: deliveryData,
            font: 'Inter',
            // barThickness: 66,
            // categoryPercentage: 1,
          },
          {
            label: 'Навынос',
            backgroundColor: '#14BF91',
            data: selfPickUpData,
            font: 'Inter',
            // barThickness: 66,
            // categoryPercentage: 1,
          }
        ]
      };
    }
  }
}
</script>


<style scoped>
.custom-class {
  width: 100%;
  /* 100% ширины родительского контейнера */
  height: 352px;
  /* 50% от высоты окна просмотра */
  position: relative;
  /* Для корректного рендеринга Chart.js */
}
</style>